<script setup lang="ts">
import { computed } from 'vue';

import { AppTag } from '@libs/ui';

import type { HotelStayTag, StayTagData } from './StayTag.model';
import { getStayTagData } from './StayTag.helper';

interface StayTagProps {
  stayTag: HotelStayTag;
  wide: boolean;
  shortVersion?: boolean;
}
const props = defineProps<StayTagProps>();
const stayAppTag = computed<StayTagData>(() => getStayTagData(props.stayTag));
</script>

<template>
  <AppTag
    :type="stayAppTag.type"
    class="stay-tag"
    :class="{ wide: props.wide, small: props.shortVersion }"
  >
    <template #title>
      <span class="hotel-stay-booking-label-highlighted">
        {{ stayAppTag.title }}
      </span>
      <span v-if="!props.shortVersion" class="hotel-stay-booking-label-text">
        {{ stayAppTag.text }}
      </span>
    </template>
  </AppTag>
</template>

<style scoped lang="scss">
.stay-tag {
  width: max-content;
  &.wide {
    width: 100%;
  }
  &.small {
    padding: var(--spacing-4) var(--spacing-8);
  }

  .hotel-stay-booking-label-highlighted {
    color: var(--color-secondary-40);
    font: var(--font-label-s-bold);
  }
  .hotel-stay-booking-label-text {
    white-space: nowrap;
  }
}
</style>
